import { produce } from 'immer';

import { ChangeIdCampaignServiceEditor } from '../../actions/campaignServiceEditor/changeIdCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function changeIdCampaignServiceEditor(
    state: CampaignServiceEditorState,
    action: ChangeIdCampaignServiceEditor
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { editorId, serviceId } = action;

        draft[editorId].serviceId = serviceId;
        draft[editorId].errors = [];
    });
}
